import {Quad} from 'gsap';
import gsap from 'gsap';
import React from 'react';

import '../../scss/play-area.scss'



import { liveRoundMenuCloseHeight , liveMenuDescriptionHeight , buttonHeight , getAboveIcon , getBellowIcon } from '../../utils/constants';
import { LiveMenuState } from './LiveRound';

import { PlayAreaProps } from './Interfaces';
import { PlayAreaState , BetType } from './Enums';
import App from '../../App';


class PlayArea extends React.Component<PlayAreaProps>{

    state = {width:0 , height:0 , playAreaState:PlayAreaState.close}

    playButtons                     = React.createRef<HTMLDivElement>();
    playArea                        = React.createRef<HTMLDivElement>();
    divL                            = React.createRef<HTMLDivElement>();
    divR                            = React.createRef<HTMLDivElement>();
    contentL                            = React.createRef<HTMLDivElement>();
    contentR                            = React.createRef<HTMLDivElement>();

    componentDidMount = ()=>{
        if(this.state.width === 0 && this.state.height === 0){        
            this.doResize(this.playArea.current.clientWidth * 0.5 , this.playArea.current.clientHeight);
            setTimeout(() => {
                this.setPlayAreaState(PlayAreaState.close);
            }, 100);
            
            window.addEventListener('resize' , this.onResize);
        }
    }

    componentWillUnmount = ()=>{
        window.removeEventListener('resize' , this.onResize);
    }

    onResize = (evt : Event)=>{
        this.doResize(this.playArea.current.clientWidth * 0.5 , this.playArea.current.clientHeight);
    }

    doResize = ( newWidth : number , newHeight : number)=>{

        this.setState({width:newWidth , height:newHeight})

    }

    buttonHandler = (value:BetType)=>{
        this.props.makeBetHandler(value);
        this.openButton(value);
        this.setPlayAreaState(PlayAreaState.open);
    }

    setPlayAreaState(state : PlayAreaState){
        this.setState({playAreaState:state});

        switch(state){
            case PlayAreaState.close:
                this.closeButton();
                break;
            case PlayAreaState.open:

                break;  
            case PlayAreaState.lower:
                this.lowerBackground(LiveMenuState.close);
                break;    
        }
    }

    openButton = (value : BetType)=>{

    

        const time = 0.3;

      

        gsap.to(this.playArea.current , {
            height:`100%`,
            duration:time,
            ease:Quad.easeOut,
            onUpdate:()=>{
                this.onResize(new Event(''));
            }
        })

        gsap.to(this.divL.current , {
            width: value === BetType.closeAbove ? window.innerWidth * 1.1 : 0 ,
            scale:value === BetType.closeAbove ? 1.5 : 1,
            duration:time,
            ease:Quad.easeOut
        })

        gsap.to(this.divR.current , {
            width: value === BetType.closeAbove ? 0 : window.innerWidth * 1.1 ,
            scale:value === BetType.closeAbove ? 1 : 1.5,
            duration:time,
            ease:Quad.easeOut
        })

        gsap.to(this.contentL.current , {
            opacity: 0,
            duration:time,
            ease:Quad.easeOut
        })

        gsap.to(this.contentR.current , {
            opacity: 0,
            duration:time,
            ease:Quad.easeOut
        })
    }

    closeButton = ()=>{



        const time = 0.3;


        gsap.to(this.playArea.current , {
            height:`${buttonHeight}%`,
            bottom:`0px`,
            duration:time,
            ease:Quad.easeOut,
            onUpdate:()=>{
                this.onResize(new Event('ok'));
            }
        })

        gsap.to(this.divL.current , {
            width:window.innerWidth * 0.5,
            scale:1,
            duration:time,
            ease:Quad.easeOut
        })

        gsap.to(this.divR.current , {
            width:window.innerWidth * 0.5,
            scale:1,
            duration:time,
            ease:Quad.easeOut
        })

        gsap.to(this.contentL.current , {
            opacity: 1,
            duration:time,
            ease:Quad.easeOut
        })

        gsap.to(this.contentR.current , {
            opacity: 1,
            duration:time,
            ease:Quad.easeOut
        })
    }

    lowerBackground = (liveMenuState : LiveMenuState)=>{

        let bottom = 0;

        if(this.state.playAreaState === PlayAreaState.close){
            if(liveMenuState === LiveMenuState.open)
                bottom += liveMenuDescriptionHeight;
        }
        else{
            bottom = liveRoundMenuCloseHeight + 10;
            if(liveMenuState === LiveMenuState.open)
                bottom += liveMenuDescriptionHeight;
        }
       
        

        gsap.to(this.playArea.current , {
            bottom:`-${bottom}px`,
            duration:0.5,
            ease:Quad.easeOut,
            onUpdate:()=>{
                this.onResize(new Event('ok'));
            }
        })
    }

    render(){

        return (
            <div ref={this.playArea}className="play-area">
                <div ref={this.playButtons} id='play-area-buttons' className="play-area-buttons">
                   <div ref={this.divL} onClick={()=>{this.buttonHandler(BetType.closeAbove)}} className="play-area-button-left" >
                    <div  ref={this.contentL} className='button-content'>
                        {getAboveIcon(App.getPropertyFromStyle('--buttons-font-color'))}
                        <p className="svg-text-header">Close above</p>
                        <p className="svg-text">{`${this.props.openContest?.moonOdds?.toFixed(2) || 0}`}</p>
                    </div>
                    <div className='play-button-background-left'></div>
                   </div>
                   <div ref={this.divR} onClick={()=>{this.buttonHandler(BetType.closeBellow)}} className="play-area-button-right" >
                   <div ref={this.contentR} className='button-content'>
                        {getBellowIcon(App.getPropertyFromStyle('--buttons-font-color'))}
                        <p className="svg-text-header">Close below</p>
                        <p className="svg-text">{`${this.props.openContest?.rektOdds?.toFixed(2) || 0}`}</p>
                    </div>
                   <div className='play-button-background-right'></div>
                   </div>
                </div>
            </div>
        )

    }    
}

export default PlayArea;
